import { Accordion } from '@augmentt-dev/ui-components'
import PropTypes from 'prop-types'
import React from 'react'
import { FormattedMessage } from 'react-intl'
import ReviewTemplatePanel from '../ReviewTemplatePanel'

const propTypes = {
  /**
   * Selected templates
   */
  selectedTemplates: PropTypes.array, // eslint-disable-line react/forbid-prop-types
  /**
   * map of form options that are non tenant specific
   */
  globalFormOptionsMap: PropTypes.object, // eslint-disable-line react/forbid-prop-types
}

const defaultProps = {
  selectedTemplates: [],
  globalFormOptionsMap: {},
}

function SelectedTemplatesView(props) {
  const { selectedTemplates, globalFormOptionsMap } = props

  if (!selectedTemplates?.length) {
    return null
  }

  return (
    <>
      <div className="text-strong mb-4">
        <FormattedMessage id="POLICY_GROUP.POLICY_DETAILS" />
      </div>
      <div className="text-color-secondary text-bold mb-4">
        <FormattedMessage id="POLICY_GROUP.SELECTED_TEMPLATES" />
      </div>

      <Accordion
        appearance="clean"
        showArrow
        arrowPosition="start"
        highlightOpenedTab
        defaultCollapsed
        tabs={selectedTemplates.map((template) => ({
          id: template?.id,
          label: template?.template_name,
          content: (
            <ReviewTemplatePanel
              key={template?.id}
              templateDescription={template?.template_description}
              rawPolicy={template?.meta_data?.policyBody}
              promptedInputs={template?.meta_data?.promptedInputs}
              globalFormOptionsMap={globalFormOptionsMap}
              hideName
              headlessDetails
            />
          ),
        }))}
      />
    </>
  )
}

SelectedTemplatesView.propTypes = propTypes
SelectedTemplatesView.defaultProps = defaultProps

export default SelectedTemplatesView
